export default "__VITE_ASSET__Cybjk1ja__"